/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductionSubmissionVMApiResponse } from '../models/ProductionSubmissionVMApiResponse';
import type { UpdateDataSubmissionVM } from '../models/UpdateDataSubmissionVM';
import type { UpdatePlantProductionSubmissionVM } from '../models/UpdatePlantProductionSubmissionVM';
import { request as __request } from '../core/request';

export class PlantProductionsService {

    /**
     * @returns ProductionSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async getPlantProductionSubmission({
id,
}: {
id?: number,
}): Promise<ProductionSubmissionVMApiResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/plant-production`,
            query: {
                'id': id,
            },
        });
        return result.body;
    }

    /**
     * @returns ProductionSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async updateProduction({
requestBody,
}: {
requestBody?: UpdatePlantProductionSubmissionVM,
}): Promise<ProductionSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/plant-production/Update`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns ProductionSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async updatePlantProductionDataSubmission({
requestBody,
}: {
requestBody?: UpdateDataSubmissionVM,
}): Promise<ProductionSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/plant-production/Update-DataSubmission`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns ProductionSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async submitProduction({
requestBody,
}: {
requestBody?: UpdateDataSubmissionVM,
}): Promise<ProductionSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/plant-production/Submit`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns ProductionSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async clearAllPlantProduction({
requestBody,
}: {
requestBody?: UpdateDataSubmissionVM,
}): Promise<ProductionSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/plant-production/Clear-All`,
            body: requestBody,
        });
        return result.body;
    }

}